var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('div',{ref:"el",staticClass:"logo__inner"},[_c('shotcode',{attrs:{"text":"Labyrinth Labyrinth","size":"logo","refresh":true}})],1)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7be366c6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Logo.vue
// module id = p8BT
// module chunks = 0